import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from "@mui/material"
import { forwardRef, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { lgDocPath } from "../../../../constants/languageDocPaths";
import { timeZones } from "../../../../constants/timeZones";
import axios from "axios";
import { debounceFunction } from "../../../../utils/utilFunctions";
import Split from "react-split";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';


// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import { TableVirtuoso } from 'react-virtuoso';

export const TimeZone = ({id, inputValue, setInputValue}) => {
  //util
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const timezoneLabel = t("LBL_TIMEZONE");
  
  //redux
  const parentScreen = useContext(ParentScreenCtx);
  const queryParams = useSelector((state) => state.queryParams);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const templateHeader = rightTree.tree.templateHeader;

  //states
  const [modalOpen, setModalOpen] = useState(false);
  
  
  const handleInputChange = (e) => {
    setInputValue(e?.target?.value);
  }

  const handleBtnClick = (e) => {
    setModalOpen(true);
  }

  return (
    <div className="flex" style={{flex: "1", minWidth: "180px", width: "unset"}}>
      <TextField
        id={id}
        size="small"
        variant="outlined"
        label={timezoneLabel}
        value={inputValue}
        onChange={handleInputChange}
        className="width-100"
        sx={{borderRadius: "0px", height: "34px"}}
        InputProps={{
          sx: {paddingRight: "0px", height: "34px" },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="field identifier"
                onClick={handleBtnClick}
                sx={{paddingBottom: "12px !important", borderRadius: "0px", height: "3px"}}
              >
                <b>...</b>
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {/* <Button
        variant="outlined"
        size="small"
        onClick={handleBtnClick}
        
        style={{width: "32px", minWidth: "32px", height: "34px"}}
      >
        <b>...</b>
      </Button> */}
      <TimeZoneModal 
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        initialValue={inputValue}
        setInitialValue={setInputValue}
      />
    </div>
  )
}

export const TimeZoneModal = ({modalOpen, setModalOpen, initialValue, setInitialValue}) => {
  const { t } = useTranslation();
  const queryParams = useSelector((state) => state.queryParams);
  const docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/timezone.html`;
  const [modalInputValue, setModalInputValue] = useState(initialValue || '');
  const [currentTime, setCurrentTime] = useState(new Date());
  const [newTime, setNewTime] = useState("")
  const [newTimezone, setNewTimezone] = useState("");
  const [newSecond, setNewSecond] = useState("");

  const handleModalInputChange = (e) => {
    setModalInputValue(e?.target?.value);
  }

  const handleApply = () => {
    setInitialValue(modalInputValue);
    setModalOpen(false);
  }

  const handleCancel = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    setModalInputValue(initialValue);
  }, [modalOpen]);

  useEffect(() => {
    // adjustTimeZone();
    return debounceFunction(() => getTimeZone(modalInputValue));
  }, [modalInputValue]);

  // useEffect(() => {
  //   const currTimeInterval = setInterval(() => {
  //     setCurrentTime(new Date());
  //     adjustTimeZone();
  //   }, 5000);

  //   return () => {
  //     clearInterval(currTimeInterval);
  //   }
  // });

  const getTimeZone = (text) => {
    const handleSuccess = (msg) => {
      try {
        let tzSplit = msg.split("\n")[3].split(":");
        setNewTimezone(`${tzSplit[1]}:${tzSplit[2]}`);
        setNewSecond(`${tzSplit[3]}`);
        // adjustTimeZone();
      } catch(e) {
        // case format received incorrectly. log for future dev use
        console.log('timezone format received incorrectly', e);
      }
      
    }
    const handleFailure = (err) => {
      
    }

    if (Object.keys(timeZones).includes(text)) {
      const requestUrl = `${queryParams.baseUrl}/workbench`;

      const urlParams = {
        action: 'validate_timezone',
        user: queryParams.user,
        account: queryParams.account,
        test_data: text || '',
      }
      axios.get(requestUrl, {
        params: urlParams,
        headers:  {
          "Authorization": `Bearer ${queryParams.token}`
        } 
      }).then((response) => {
        if (response?.data?.message) handleSuccess(response.data.message);
      }).catch((error) => {
        //dev log incase this needs to be tested and handled. Will be removed later.
        handleFailure(error);
      })
    } else {
      setNewTimezone("");
      setNewSecond("");
    }
  }

  const adjustTimeZone = () => {
    const min2Digit = (num) => {
      return num < 10 && num.toString().length === 1 ? "0" + num : num;
    }
    let offsetStr = "0:00";
    if (Object.keys(timeZones).includes(modalInputValue)) {
      offsetStr = timeZones[modalInputValue];
      // console.log(currentTime.toLocaleTimeString(
      //   'en-US', 
      //   {year: "numeric", month: "numeric", day: "numeric"}
      // ));
      let standardTime = currentTime.toLocaleTimeString(
        [], {timeZone: "GB", hour12: false, hour: "2-digit", minute: "2-digit", formatMatcher: "best fit", year: "2-digit", month: "2-digit", day: "2-digit" }
      )
      let date = standardTime.split(', ')[0];
      let time = standardTime.split(', ')[1];

      let month = date.split('/')[0];
      let day = date.split('/')[1];
      let year = date.split('/')[2];

      let hour = time.split(":")[0];
      let min = time.split(":")[1];
      let sec = time.split(":")[2];

      let offsetHour = offsetStr.split(":")[0];
      let offsetMin = offsetStr.split(":")[1];

      let newDay = day;
      let newMonth = month;
      let newYear = year;

      if (offsetStr.includes('+')) {
        let newHour = parseInt(offsetHour.replace("+", "")) + parseInt(hour);
        let newMin = parseInt(offsetMin) + parseInt(min);
    
        if (newMin > 60) {
          newMin = newMin - 60;
          newHour = 1 + newHour;
        } 
        if (newHour > 24) {
          newDay = 1 + newDay;
          newHour = newHour - 24;
        }
        setNewTime(`${min2Digit(newMonth)}/${min2Digit(newDay)}/${min2Digit(newYear)}, ${min2Digit(newHour)}:${min2Digit(newMin)}`);
      } else if (offsetStr.includes('-')) {
        let newHour = parseInt(offsetHour.replace("+", "")) - parseInt(hour);
        let newMin = parseInt(offsetMin) - parseInt(min);
        if (newMin < 0) {
          newMin = 0 - newMin;
          newHour = newHour - 1;
        } 
        if (newHour < 0) {
          newDay = newDay - 1;
          newHour = newHour + 24;
        }
        setNewTime(`${min2Digit(newMonth)}/${min2Digit(newDay)}/${min2Digit(newYear)}, ${min2Digit(newHour)}:${min2Digit(newMin)}`);
      } else {
        //is UTC.
        setNewTime(standardTime);
      }
    } else {
      setNewTimezone("");
      setNewSecond("");
      // setNewTime(`error${t("INVALID_TIMEZONE")} ${t("INBOUND_TIMEZONE_USED")}`)
    }
    
  }

  //format Date.now()
  const CurrentTimeFormatted = () => {
    const now = new Date();

    //organize time segments
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    // Pad single digits with leading zeros
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDay = day < 10 ? '0' + day : day;
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    return (<>{`${year}/${formattedMonth}/${formattedDay} ${formattedHours}:${formattedMinutes}`}</>);
  }

  return (
    <>
      <Dialog 
        open={modalOpen} 
        onClose={() => setModalOpen(false)}
        maxWidth={"lg"} 
        fullWidth={true}
        style={{height: "100%"}}
      >
        <DialogTitle className="dialog-header">
          <div className="title">
            {t("DIAG_TIMEZONE_BUILDER_TIT")}
          </div>
          <div className="description">
            <div style={styles.contentHeader}>
              {t('DIAG_TIMEZONE_BUILDER_DESC')}
            </div>
            {/* <div style={styles.importantMessage}>
              <b>{t('IMPORTANT')}</b>: {t('TIMEZONE_WARNING')}
            </div> */}
            {/* {t("DIAG_TIMEZONE_BUILDER_DESC")} */}
          </div>
          <Button 
            size="small" 
            style={{position: "absolute", top: "8px", right: "8px", width: "32px", minWidth: "32px", marginRight: "0"}}
            onClick={() => setModalOpen(false)}
          >
            <CloseOutlinedIcon style={{fontSize: "24px"}}/>
          </Button>
        </DialogTitle>
        <DialogContent style={{ padding: "0px", overflow: "hidden", fontSize: "12px", fontWeight: "400", maxHeight: "580px", height: "580px" }} dividers>
          <Split
            style={{ height: "100%" }}
            className="split width-100 flex"
            direction="horizontal"
            gutterSize={4}
            snapOffset={0}
            dragInterval={4}
            minSize={[50, 50]}
            sizes={[50, 50]}
          >
            <div style={styles.leftContainer}>
              {/* <ReactVirtualizedTable /> TODO: Virtualized table can be made for this component in the future.*/} 
              <div className="table-border height-100">
                <iframe
                  style={styles.iframe}
                  title="timeZoneHelp"
                  src={docPath}
                />
              </div>
            </div>
            <div style={styles.rightContainer}>
             <span ><b>{t("LBL_ENTER_TIMEZONE_HERE")}</b></span>
              <TextField
                id="timezoneInput"
                size="small"
                variant="outlined"
                value={modalInputValue}
                onChange={handleModalInputChange}
                style={{marginTop: "2px"}}
                hiddenLabel
                autoFocus={true}
              />

              <div className="flex margin-top-12">
                <div style={{paddingRight: "16px"}}>
                  <div className="margin-top-4"><b>{t("CURRENT_TIMEZONE")}</b></div>
                  <div className="margin-top-4"><b>{t("CONVERTED_TIMEZONE")}</b></div>
                </div>
                <div style={{flex: "1"}}>
                  <div className="margin-top-4"><CurrentTimeFormatted/>:{newSecond}</div>
                  <div className="margin-top-4">
                    {newTimezone && newTimezone.length ? `${newTimezone}:${newSecond}` : (
                      modalInputValue && modalInputValue.length > 0 ? (
                        <span className="error">{`${t("INVALID_TIMEZONE")} ${t("INBOUND_TIMEZONE_USED")}`}</span>
                      ) : (
                        <><CurrentTimeFormatted/>:{newSecond}</>
                      )
                    )}
                  </div>
                </div>
              </div>

              {/* <div>
                <span className="margin-right-8">
                  <b>{t("CURRENT_TIMEZONE")}</b>&nbsp;
                  <CurrentTimeFormatted/>
                </span>
              </div> 
              <div className="flex">
                <div><b>{t('CONVERTED_TIMEZONE')}</b>&nbsp;</div>
                <div>
                  {newTimezone && newTimezone.length ? newTimezone : (
                    <span className="error">{`${t("INVALID_TIMEZONE")} ${t("INBOUND_TIMEZONE_USED")}`}</span>
                  )}
                </div>
              </div> */}
            </div>
          </Split>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="sm"
            onClick={handleCancel}
            style={styles.popupBtn}
            // className="margin-right-16"
          >
            {t("BTN_CANCEL")}
          </Button>
          <Button
            variant="outlined"
            size="sm"
            onClick={handleApply}
            style={styles.popupBtn}
          >
            {t("APPLY")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const styles = {
  popupBtn: {
    minWidth: "40px"
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    height: "100%",
    boxSizing: "border-box",
    padding: "16px"
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    minWidth: "280px",
    height: "unset",
    boxSizing: "border-box",
    padding: "16px"
  },
  importantMessage: {
    // opacity: "0.75",
  },
  modalContentContainer: {
    display: 'flex',
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    fontSize: "12px"
  },
  infoSection: {
    padding: "16px 24px"
  },
  contentHeader: {
    // fontSize: "14px",
  },
  tableContainer: {
    padding: "16px 24px",
  },
  bottomContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    borderTop: "1px solid #e0e0e0",
    padding: "8px 0"
  },
  bottomLeftContainer: {
    display: "flex",
    paddingLeft: "24px"
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    paddingRight: "24px"
  },
  inputContainer: {
    marginRight: "16px",
    display: "flex",
    alignItems: "center"
  },
  iframe: { 
    boxSizing: "border-box",
    border: "none",
    width: '100%', 
    height: '100%'
  }
}


//TODO: not enough time right now to make a quality table. Will instead use the timezone help doc.

// function createData(id, timeZone, text, conversion, value) {
//   return { id, timeZone, text, conversion, value};
// }

// const columns = [
//   {
//     // width: 200,
//     label: 'TimeZone',
//     dataKey: 'timeZone',
//   },
//   {
//     // width: 120,
//     label: 'Text to Specify',
//     dataKey: 'text',
//   },
//   {
//     // width: 120,
//     label: 'Conversion',
//     dataKey: 'conversion',
//   },
// ];

// const rows = Array.from({ length: 200 }, (_, index) => {
//   const randomSelection = sample[Math.floor(Math.random() * sample.length)];
//   return createData(index, ...randomSelection);
// });

// const VirtuosoTableComponents = {
//   Scroller: forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table {...props} stickyHeader sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
//   ),
//   TableHead,
//   TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
//   TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// function fixedHeaderContent() {
//   return (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align={column.numeric || false ? 'right' : 'left'}
//           style={{ width: column.width }}
//           sx={{
//             backgroundColor: 'background.paper',
//           }}
//         >
//           {column.label}
//         </TableCell>
//       ))}
//     </TableRow>
//   );
// }

// function rowContent(_index, row) {
//   console.log(_index, row);
//   return (
//     <>
//       {columns.map((column) => {
//         console.log(column);
//         let display = column.dataKey === 'conversion' ? "12:56" : row[column.dataKey]
//         return (
//           <TableCell
//             size="small"
//             key={column.dataKey}
//             // align={column.numeric || false ? 'right' : 'left'}
//           >
//             {/* {row[column.dataKey]} */}
//             {display}
//           </TableCell>
//         )}
//       )}
//     </>
//   );
// }

// export default function ReactVirtualizedTable() {
//   return (
//     <Paper style={{ 
//       height: "100%", 
//       maxHeight: "800px", 
//       minHeight: "150px", 
//       width: '100%',
//       boxShadow: "none" 
//     }}>
//       <TableVirtuoso
//         data={rows}
//         components={VirtuosoTableComponents}
//         size={"small"}
//         fixedHeaderContent={fixedHeaderContent}
//         itemContent={rowContent}
//         style={{boxShadow: "none", border: "1px #e0e0e0 solid" }}
//       />
//     </Paper>
//   );
// }
